import { ServiceInstructionFormType } from 'components/service-instructions/ServiceInstructionForm';
export const createServiceInstructionsInitialValues: Partial<ServiceInstructionFormType> = {};
